import { ReactElement } from 'react';
import { UIText } from '@/ui';
import styles from './no-access-mask.module.scss';
import { useTasksTranslation } from '../hooks';

type NoAccessMaskProps = {
    withMessage?: 'no-subscription' | 'no-license';
};

export function NoAccessMask(props: NoAccessMaskProps): ReactElement {
    const { withMessage } = props;
    const { t } = useTasksTranslation();

    return (
        <div className={styles.container}>
            {withMessage === 'no-subscription' && (
                <>
                    <UIText variant="h2">
                        {t('components.no_access_mask.no_subscription_title')}
                    </UIText>
                    <UIText type="default2">
                        {t(
                            'components.no_access_mask.no_subscription_description'
                        )}
                    </UIText>
                </>
            )}

            {withMessage === 'no-license' && (
                <>
                    <UIText variant="h2">
                        {t('components.no_access_mask.no_license_title')}
                    </UIText>
                    <UIText type="default2">
                        {t('components.no_access_mask.no_license_description')}
                    </UIText>
                </>
            )}
        </div>
    );
}
